// extracted by mini-css-extract-plugin
module.exports = {"afterText":"e_2","cards":"e_3","advTitle":"e_4","formTitle":"e_5","advButton":"e_6","formContainer":"e_7","formContainerSubmitting":"e_8","formTextarea":"e_9","formButton":"e_-"};